import { User, UserRole } from '@modules/core/types';
import { TeamListItem } from '@modules/teams/types';

export const isUserAdministrator = (user: User | TeamListItem): boolean => {
  return user.profile.pp_role?.toLocaleLowerCase() === UserRole.ADMINISTRATOR.toLocaleLowerCase();
};
